<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Vendor Info

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">



        <ul class="nav nav-tabs nav-tab-service margin-top-13px" id="tabContent">
          <li class="active margin-right-15px"><a class="nav-item2 active" href="#details" data-toggle="tab">1.Registration</a></li>
          <!--<li class="margin-right-15px"><a class="nav-item2" href="#details" data-toggle="tab">1.Registration</a></li>-->
          <li class="margin-right-15px"><a class="nav-item2" href="#address" data-toggle="tab">2.Address</a></li>
          <li class="margin-right-15px"><a class="nav-item2" href="#contact" data-toggle="tab">3.Contact</a></li>
          <li class="margin-right-15px"><a class="nav-item2" href="#credentials" data-toggle="tab">4.Credentials</a></li>
          <li class="margin-right-15px"><a class="nav-item2" href="#supmaterial" data-toggle="tab">5.Supplier Materials</a></li>

        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="details">

            <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Name </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Name"
                                         id="CurrentSaveVendorInformationRequest.DisplayName"
                                             [(ngModel)]="CurrentSaveVendorInformationRequest.DisplayName"
                                             name="CurrentSaveVendorInformationRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                         maxlength="100" />
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Short Name </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Short Name"
                                         id="CurrentSaveVendorInformationRequest.VendorShortName"
                                             [(ngModel)]="CurrentSaveVendorInformationRequest.VendorShortName"
                                             name="CurrentSaveVendorInformationRequest.VendorShortName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>


          </div>

          <div class="tab-pane" id="address">

            <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line1 </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Address Line1"
                                         id="CurrentSaveVendorInformationRequest.AddressLine1"
                                             [(ngModel)]="CurrentSaveVendorInformationRequest.AddressLine1"
                                             name="CurrentSaveVendorInformationRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                         maxlength="100" />
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line2 </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Address Line2"
                                         id="CurrentSaveVendorInformationRequest.AddressLine2"
                                         [(ngModel)]="CurrentSaveVendorInformationRequest.AddressLine2"
                                         name="CurrentSaveVendorInformationRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="100" />

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Country </label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="CNTR"
                                                 id="CurrentSaveVendorInformationRequest.Country" PassType="Long"
                                                 [(ngModel)]="CurrentSaveVendorInformationRequest.Country" SelectedValue="{{CurrentSaveVendorInformationRequest.Country}}"
                                                 name="CurrentSaveVendorInformationRequest.Country" #CNTR="ngModel">
                                  </CodeTypeValue>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">State </label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="State"
                                                 id="CurrentSaveVendorInformationRequest.State" PassType="Long"
                                                 [(ngModel)]="CurrentSaveVendorInformationRequest.State" SelectedValue="{{CurrentSaveVendorInformationRequest.State}}"
                                                 name="CurrentSaveVendorInformationRequest.State" #State="ngModel">
                                  </CodeTypeValue>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">City </label>
                                </div>
                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="City"
                                                 id="CurrentSaveVendorInformationRequest.City" PassType="Long"
                                                 [(ngModel)]="CurrentSaveVendorInformationRequest.City" SelectedValue="{{CurrentSaveVendorInformationRequest.City}}"
                                                 name="CurrentSaveVendorInformationRequest.City" #City="ngModel">
                                  </CodeTypeValue>

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Zip Code</label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Zip Code"
                                         id="CurrentSaveVendorInformationRequest.Zip"
                                         [(ngModel)]="CurrentSaveVendorInformationRequest.Zip"
                                         name="CurrentSaveVendorInformationRequest.Zip"
                                         maxlength="6" pattern="[0-9]{6}">
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>


          </div>
          <div class="tab-pane" id="contact">

            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Telephone </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" placeholder="Telephone"
                                         mask="(000) 000-0000" pattern="[0-9]{10}" />

                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Mobile Phone </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         mask="(000) 000-0000" pattern="[0-9]{10}" />

                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address">Email Address  </label>
                                </div>
                                <div class="col-md-4">

                                  <input type="email" class="form-control"
                                         placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                         maxlength="30" minlength="4">
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>

          <div class="tab-pane" id="credentials">

            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row">
                            <div class="col-md-10">

                            </div>
                            <div class="col-md-2 padding-right-0px text-align-right">
                              <a (click)="AddNewCredential()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Credential"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                            </div>
                            <!--<div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">

                          <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">

                    </div>-->
                          </div>

                          <div class="row">
                            <div class="col-md-12 padding-right-0px">
                              <div class="table-component margin-bottom-0px">
                                <div class="table-responsive overflow-x">


                                  <table class="table table-striped margin-left-zero width-100pe"
                                         cols="auto,2*,*,*,*,*,*,*">

                                    <thead class="">
                                      <tr>

                                        <th class="">
                                          Name
                                        </th>

                                        <th class="">
                                          NO
                                        </th>
                                        <th class="">
                                          Issuing Authority
                                        </th>

                                        <th class="">
                                          Valid From
                                        </th>
                                        <th class="">
                                          Valid To
                                        </th>

                                        <th class="">
                                          Additional Info
                                        </th>

                                        <th class="">
                                          Remarks
                                        </th>

                                        <th class="">

                                        </th>

                                      </tr>
                                    </thead>

                                    <tbody class="table-body">
                                      <tr>

                                        <td class="td-padding-tb">CPR</td>
                                        <td class=" td-padding-tb">AB4582</td>
                                        <td class=" td-padding-tb">ACS</td>
                                        <td class="td-padding-tb">10-08-2017</td>
                                        <td class="td-padding-tb ">15-06-2022</td>
                                        <td class="td-padding-tb ">Add info</td>
                                        <td class="td-padding-tb ">abc</td>
                                        <td class=" td-padding-tb ">
                                          <div class="test-icons">
                                            <a (click)="EditNewCredential()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                            <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                          </div>
                                        </td>
                                      </tr>

                                    </tbody>

                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>

          <div class="tab-pane" id="supmaterial">

            <form class="form" novalidate="" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row">
                            <div class="col-md-10">

                            </div>
                            <div class="col-md-2 padding-right-0px text-align-right">
                              <a (click)="AddNewsuplMaterials()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New SupMaterials"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                            </div>
                            <!--<div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">

                          <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">

                    </div>-->
                          </div>

                          <div class="row">
                            <div class="col-md-12 padding-right-0px">
                              <div class="table-component margin-bottom-0px">
                                <div class="table-responsive overflow-x">


                                  <table class="table table-striped margin-left-zero width-100pe"
                                         cols="auto,2*,*,*,*,*,*,*">

                                    <thead class="">
                                      <tr>

                                        <th class="">
                                          Specification Details
                                        </th>

                                        <th class="">
                                          Min Ord Qty
                                        </th>
                                        <th class="">
                                          Max Ord Qty
                                        </th>

                                        <th class="">
                                          Lead Time(days)
                                        </th>
                                        <th class="">
                                          Has Rate Contract
                                        </th>

                                        <th class="">

                                        </th>

                                      </tr>
                                    </thead>

                                    <tbody class="table-body">
                                      <tr>

                                        <td class="td-padding-tb">EEMA HP 5000 IU</td>
                                        <td class=" td-padding-tb">1</td>
                                        <td class=" td-padding-tb">20</td>
                                        <td class="td-padding-tb">10</td>
                                        <td class="td-padding-tb ">Yes</td>
                                        <td class=" td-padding-tb ">
                                          <div class="test-icons">
                                            <a (click)="EditNewsuplMaterials()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                            <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                          </div>
                                        </td>
                                      </tr>

                                    </tbody>

                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>

        </div>



      </div>
      
    </div>
  </div>
</div>
